import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import Lottie from "lottie-react";
// import LoadingAnimation from "../animations/Progress Bar.json";
import loadingAnimation from "../animations/Abstract Isometric Loader #1.json";
import "./LoadingScreen.css";
import LoadingAnimation from "./LoadingAnimation";

const LoadingScreen = ({ isLoading, dataLoaded }) => {
  const [fillWidth, setFillWidth] = useState(0);

  useEffect(() => {
    if (isLoading) {
      const interval = setInterval(() => {
        setFillWidth((prev) => {
          if (prev < 90) return prev + 1; // Increase fill up to 90%
          return prev;
        });
      }, 30);

      return () => clearInterval(interval);
    } else {
      // Complete filling when loading is done
      setFillWidth(100);
    }
  }, [isLoading]);

  return createPortal(
    <div className="loading-container">
      <div className="where-tag">Starting up🚀</div>
      <span>
        The server is waking up. This may take a few seconds on the first visit.
      </span>
      <br />
      <LoadingAnimation />
      {/* <div className="loading-text">
        <div className="loading-background">Loading</div>
        <div className="loading-fill" style={{ width: `${fillWidth}%` }} />
      </div> */}
    </div>,
    document.getElementById("loading-root") // Create this div in your public/index.html file
  );
};

export default LoadingScreen;
